// --------------------------------------------------------- Pagination ---------------------------------------------------------

/**
 * The default page sizes of the table pagination
 */
export const DefaultPageSizes = [
    10 as const,
    20 as const,
    50 as const,
    100 as const,
];


/**
 * The default pagination info of the application
 */
export const DefaultPaginationInfo = {
    pageSize: DefaultPageSizes[0],
    length: 0 as const,
    currentPage: 1 as const,
    sizes: DefaultPageSizes,
}


// --------------------------------------------------------- Code Formats ---------------------------------------------------------

/**
 * The existing formats of the codes in this application.
 */
export enum CodeFormats {
    qrCode = 'qrCode',
    barCode = 'barCode'
}

/**
 * The existing content type ids for the codes in this application.
 */
export enum CodeFormatIds {
    qrCode = 1,
    barCode = 2,
}

/**
 * The map of the content type to the content type id.
 */
export const CodeFormatFormatIdMap = {
    [CodeFormats.qrCode]: CodeFormatIds.qrCode as const,
    [CodeFormats.barCode]: CodeFormatIds.barCode as const,
}
/**
 * The map of the content type id to the content type.
 */
export const CodeFormatIdFormatMap = {
    [CodeFormatIds.qrCode]: CodeFormats.qrCode as const,
    [CodeFormatIds.barCode]: CodeFormats.barCode as const,
}

export const CodeFormatIdTitleMap = {
    [CodeFormatIds.qrCode]: "QR Code" as const,
    [CodeFormatIds.barCode]: "Barcode" as const,
}

/**
 * The map of the format to the title.
 */
export const CodeFormatTitleMap = {
    [CodeFormats.qrCode]: 'QR Code' as const,
    [CodeFormats.barCode]: 'Barcode' as const,
}


// --------------------------------------------------------- Code Content Type ---------------------------------------------------------

/**
 * The existing content types for the codes in this application.
 */
export enum CodeContentTypes {
    externalLink = "external-link",
    virtualCard = "virtual-card",
    pdf = "pdf",
    imageGallery = "image-gallery",
    socialMedia = "social-media",
    app = "app",
    video = "video",
    feedback = "feedback",
}

/**
 * The existing content type ids for the codes in this application.
 */
export enum CodeContentTypeIds {
    externalLink = 1,
    virtualCard = 2,
    pdf = 3,
    imageGallery = 4,
    socialMedia = 5,
    app = 6,
    video = 7,
    feedback = 8,
}

/**
 * The map of the content type to the content type id.
 */
export const CodeContentTypeTypeIdMap = {
    [CodeContentTypes.externalLink]: CodeContentTypeIds.externalLink as const,
    [CodeContentTypes.virtualCard]: CodeContentTypeIds.virtualCard as const,
    [CodeContentTypes.pdf]: CodeContentTypeIds.pdf as const,
    [CodeContentTypes.imageGallery]: CodeContentTypeIds.imageGallery as const,
    [CodeContentTypes.socialMedia]: CodeContentTypeIds.socialMedia as const,
    [CodeContentTypes.app]: CodeContentTypeIds.app as const,
    [CodeContentTypes.video]: CodeContentTypeIds.video as const,
    [CodeContentTypes.feedback]: CodeContentTypeIds.feedback as const,
}
/**
 * The map of the content type id to the content type.
 */
export const CodeContentTypeIdTypeMap = {
    [CodeContentTypeIds.externalLink]: CodeContentTypes.externalLink as const,
    [CodeContentTypeIds.virtualCard]: CodeContentTypes.virtualCard as const,
    [CodeContentTypeIds.pdf]: CodeContentTypes.pdf as const,
    [CodeContentTypeIds.imageGallery]: CodeContentTypes.imageGallery as const,
    [CodeContentTypeIds.socialMedia]: CodeContentTypes.socialMedia as const,
    [CodeContentTypeIds.app]: CodeContentTypes.app as const,
    [CodeContentTypeIds.video]: CodeContentTypes.video as const,
    [CodeContentTypeIds.feedback]: CodeContentTypes.feedback as const,
}
/**
 * The map of the content type id to the title.
 */
export const CodeContentTypeIdTitleMap = {
    [CodeContentTypeIds.externalLink]: "External Link" as const,
    [CodeContentTypeIds.virtualCard]: "Virtual Card" as const,
    [CodeContentTypeIds.pdf]: "PDF" as const,
    [CodeContentTypeIds.imageGallery]: "Image Gallery" as const,
    [CodeContentTypeIds.socialMedia]: "Social Media" as const,
    [CodeContentTypeIds.app]: "App" as const,
    [CodeContentTypeIds.video]: "Video" as const,
    [CodeContentTypeIds.feedback]: "Feedback" as const,
}

// ------------------------------------------------ Static Code Content Type ------------------------------------------------

/**
 * The existing static code types in this application.
 */
export enum StaticCodeContentTypes {
    text = 'text',
    wifi = 'wifi',
    email = 'email',
    sms = 'sms',
}

/**
 * The existing static code type ids in this application.
 */
export enum StaticCodeContentTypeIds {
    text = 1,
    wifi = 2,
    email = 3,
    sms = 4,
}

/**
 * The map of the static code type to the static code type id.
 */
export const StaticCodeContentTypeTypeIdMap = {
    [StaticCodeContentTypes.text]: StaticCodeContentTypeIds.text as const,
    [StaticCodeContentTypes.wifi]: StaticCodeContentTypeIds.wifi as const,
    [StaticCodeContentTypes.email]: StaticCodeContentTypeIds.email as const,
    [StaticCodeContentTypes.sms]: StaticCodeContentTypeIds.sms as const,
}

/**
 * The map of the static code type id to the static code type.
 */
export const StaticCodeContentTypeIdTypeMap = {
    [StaticCodeContentTypeIds.text]: StaticCodeContentTypes.text as const,
    [StaticCodeContentTypeIds.wifi]: StaticCodeContentTypes.wifi as const,
    [StaticCodeContentTypeIds.email]: StaticCodeContentTypes.email as const,
    [StaticCodeContentTypeIds.sms]: StaticCodeContentTypes.sms as const,
}

/**
 * The map of the static code type id to the title.
 */
export const StaticCodeContentTypeIdTitleMap = {
    [StaticCodeContentTypeIds.text]: "Text" as const,
    [StaticCodeContentTypeIds.wifi]: "Wi-Fi" as const,
    [StaticCodeContentTypeIds.email]: "Email" as const,
    [StaticCodeContentTypeIds.sms]: "SMS" as const,
}


/**
 * The visibility of the charts.
 */
export enum ChartVisibilities {
    yearly = 'yearly',
    monthly = 'monthly',
    weekly = 'weekly',
    daily = 'daily',
    hourly = 'hourly',
}


export enum PreviewContentViewMode {
    view = 'view',
    edit = 'edit'
}
